import React, { useState, useEffect } from "react";
import { useParams,useNavigate,Link } from 'react-router-dom';
import axios from 'axios';

import HeaderTitle from "../includes/HeaderTitle";
import { escapeHtml,unescapeHtml,ChangeDateStringOnlyDate,ChangeSearchingDateFormat,isNull } from "../../../components/common/Common";

//게시판 정보 편집
function QuestionDetail({setMenuItem}) {
  const admin_idx = Number(localStorage.getItem('adminIdx'));
  const admin_name = localStorage.getItem('adminName');
  let { board_idx } = useParams();
  const navigator = useNavigate();

  //게시판 변수 저장 객체
  const newData = {      
    board_idx: 0,
    answer_idx: admin_idx,
    answer_name: admin_name,
    board_num:0,
    quest_idx: admin_idx,
    quest_name: admin_name,
    quest_mobile: "",
    dr_carnumb:"",
    board_title: "",
    board_comment: "",
    board_answer: "",
    board_rdate: ChangeSearchingDateFormat(new Date(),'.'),
    board_adate: ChangeSearchingDateFormat(new Date(),'.'),
    board_hits: 0,
    board_status:1
  };

  //게시판정보
  const [varQuestionInfo,setQuestionInfo] = useState({});

  //게시판정보 읽어오기
  const getQuestionInformation = async () => {
    if(Number(board_idx) === 0) {
      setQuestionInfo(newData);
    //게시판 정보를 서버로부터 읽어오기
    } else {
      var sendData = {board_idx: board_idx};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/admin_get_question_information`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          if(datas.results?.length > 0) {
            const dataInfo = datas.results[0];
            if(dataInfo.answer_idx === 0) {
              dataInfo.answer_idx = admin_idx;
              dataInfo.answer_name = admin_name;
              dataInfo.board_adate = ChangeSearchingDateFormat(new Date(),'.');
            }
            setQuestionInfo(dataInfo);
          }
        }
      });
    }
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setMenuItem('QuestionList');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getQuestionInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [board_idx]);

  //회원정보편집
  const onQuestionInfoHandler = (e) => {
    const {name,value} = e.currentTarget;
    if(name === "board_comment" || name === "board_title"){
      setQuestionInfo({...varQuestionInfo, [name]:escapeHtml(value)});
    } else if(name === "board_answer") {
      if(varQuestionInfo.board_status !== 2 && value !== "") 
        setQuestionInfo({...varQuestionInfo, [name]:escapeHtml(value),board_status:2});
      else if(varQuestionInfo.board_status === 2 && value === "") 
        setQuestionInfo({...varQuestionInfo, [name]:escapeHtml(value),board_status:1});
      else 
        setQuestionInfo({...varQuestionInfo, [name]:escapeHtml(value)});
    } else 
        setQuestionInfo({...varQuestionInfo, [name]:value});
    }

  //공지사항정보 서버에 등록---------
  //첨부파일 업로드
  const onUpdateQuestionHandler = async (e) => {

    let prompt = "현재 선택된 1:1문의 정보를 저장합니까?";
    if(varQuestionInfo.board_idx === 0)  prompt = "입력하신 1:1문의 정보를 등록합니까?";
    if(!window.confirm(prompt)) return false;

    const sendData = {boardInfo:varQuestionInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_question_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(!isNull(varQuestionInfo.board_answer)) SendPushMessage();
      } else {
        alert(datas.message);
      }
    });
  }
  //푸시 메시지 발송
  const SendPushMessage = async() => {
    if(!window.confirm('푸시메시지를 발송합니까?')){
      navigator(`/Admin/Boards/QuestionList`);
      return false;
    } 

    const sendData = {pushMode:2,opp_idx:varQuestionInfo.quest_idx,pushMessage:varQuestionInfo.board_title};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_send_push_single_message`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        SavePushMessageHistory(varQuestionInfo.quest_idx,varQuestionInfo.board_title);
      } else {
        alert(datas.message);
        navigator('/Admin/Boards/QuestionList');
      }
    });    
  }
  //메시지발송내역 저장
  const SavePushMessageHistory = async(driver_idx,pushMessage) => {
    const sendData = {ah_mem_idxs:driver_idx,ah_mode:2,ah_message:pushMessage};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_insert_alarm_history`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        navigator('/Admin/Boards/QuestionList');
      } else {
        alert(datas.message);
      }
    });
  }

  return (    
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="게시판 관리" varPageTitle={varQuestionInfo.board_idx===0?"1:1문의등록":"1:1문의상세"} />
      <div className="admin-content">
        <div className="main-box">
          <table className="write">
            <colgroup><col width="20%"/><col width="30%"/><col width="20%"/><col width="30%"/></colgroup>
            <thead></thead>
            <tbody>
              <tr>
                <th>문의일자</th>
                <td>{ChangeDateStringOnlyDate(varQuestionInfo.board_rdate||"")}</td>
                <th>문의자</th>
                <td>{varQuestionInfo.quest_name+'('+varQuestionInfo.dr_carnumb+')'||""}</td>
              </tr>
              <tr>
                <th>답변일자</th>
                <td>{ChangeDateStringOnlyDate(varQuestionInfo.board_adate||"")}</td>
                <th>답변자</th>
                <td>{varQuestionInfo.answer_name||""}</td>
              </tr>
              <tr>
                <th>제목</th>
                <td colSpan={3}><input type="text" name="board_title" value={unescapeHtml(varQuestionInfo.board_title||"")} onChange={(e)=>onQuestionInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>내용</th>
                <td colSpan={3}><textarea name="board_comment" style={{maxWidth:"100%"}} value={unescapeHtml(varQuestionInfo.board_comment||"")} onChange={(e)=>onQuestionInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>답변</th>
                <td colSpan={3}><textarea name="board_answer" style={{maxWidth:"100%"}} value={unescapeHtml(varQuestionInfo.board_answer||"")} onChange={(e)=>onQuestionInfoHandler(e)}/></td>
              </tr>
            </tbody>
          </table>
          <div className="btn-center">
            <button className="btn-danger" style={{width:"100px"}} onClick={(e)=>onUpdateQuestionHandler(e)}>저장</button>
            <Link to={`/Admin/Boards/QuestionList`} style={{width:"100px"}} className="btn line">목록</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuestionDetail;